@for (header of getClassHeaders(); track header) {
  <div class="form-group">
    <label class="label--md">
      <img src="{{header?.icon_path}}" alt="" class="icon icon--lg">
      {{header?.class_name}}
    </label>
    @for (item of getClassItems(header.class_id); track item; let index = $index) {
      <label
        class="custom-input custom-input--checkbox custom-input--selector">
        <!-- <input
        (click)="checkRadio(item)"
        [disabled]="item?.status_id == 1 || item?.status_id == 2"
        type="radio"
        class="items"
        [name]="'class-item-' + header?.class_id"
        > -->
        <input
          (click)="checkRadio(item)"
          [disabled]="item?.status_id == 1 || item?.status_id == 2"
          type="radio"
          name="class-items">
          <span class="custom-input__label">
            <span class="custom-input__label-text">
              <h5 class="font-16">{{ getDescriptionIndex(item,0) }}</h5>
              <p class="helper-text">{{item?.description_2}}</p>
            </span>
            @if (item?.status_id == 1) {
              <svg class="icon"><use xlink:href="#progress"></use></svg>
            }
            @if (item?.status_id == 2) {
              <svg class="icon"><use xlink:href="#circle-small-included"></use></svg>
            }
          </span>
        </label>
      }
    </div>
  }

  @if (getBenefitsHeader()?.length > 0) {
    <div class="form-group">
      <label class="label--md">
        <img src="{{getBenefitsHeader()?.icon_path}}" alt="" class="icon icon--lg">
        Benefits
      </label>
      @for (benefit of getBenefits(); track benefit) {
        <label
          class="custom-input custom-input--checkbox custom-input--selector custom-input--selector-benefits">
          <input (click)="checkRadio(benefit)" type="radio" name="radio-example-{{benefit?.vaps_id}}">
          <span class="custom-input__label">
            <span class="custom-input__label-text">
              <h5 class="font-16">
                <img src="{{benefit?.icon_path}}" alt="" class="icon">
                {{benefit?.vaps_name}}
              </h5>
              @if (benefit?.description_1 && benefit?.description_2) {
                <p class="helper-text">{{benefit?.description_1}}
                - {{benefit?.description_2}}</p>
              }
            </span>
            @if (benefit?.status_id == 1) {
              <svg class="icon"><use xlink:href="#progress"></use></svg>
            }
            @if (benefit?.status_id == 2) {
              <svg class="icon"><use xlink:href="#circle-small-included"></use></svg>
            }
          </span>
        </label>
      }
    </div>
  }

  @if (getExitOption()) {
    <div class="form-group">
      <label class="label--md">Nothing More</label>
      <label class="custom-input custom-input--checkbox custom-input--selector">
        <input (click)="checkRadio(getExitOption())" type="radio" name="radio-example-1">
        <span class="custom-input__label">
          <span class="custom-input__label-text">
            <h5 class="font-16">{{getExitOption()?.description_1}}</h5>
          </span>
        </span>
      </label>
    </div>
  }
